import axios from 'axios';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AiCreationCommands } from 'redux/schemas/models/ai-course-creation';
import {
  CourseCatalogId, DeleteResponse, DeleteUploadFileID, PreviewCourseResponse,
  SearchCourseResult, SearchResultParam, UploadFilesResponse,
} from 'redux/schemas/api/ai-course-creation';

export const uploadFilesToAiCourseCreation = createAsyncThunk(
  'UPLOAD_FILES_TO_AI_COURSE_CREATION',
  (params: { courseCatalogId, fileName, fileSize, contentType, uniqueID }, thunkAPI) => axios
    .post(
      `/${params.courseCatalogId}/ai_creation_sources.json`,
      {
        ai_creation_source: {
          attachedFileName: params.fileName,
          attachedFileSize: params.fileSize,
          attachedContentType: params.contentType,
          uniqueId: params.uniqueID,
        },
      },
    )
    .then(response => (
      response.data.result
    ))
    .catch((e) => thunkAPI.rejectWithValue(e.response.data.error)),
);

export const selectOutlineFile = createAsyncThunk(
  'SELECT_OUTLINE_FILE',
  async (params: { catalogId: string; aiCreationSourceId: number }, thunkAPI) => {
    try {
      const response = await axios.post(`/${params.catalogId}/ai_creation_sources/${params.aiCreationSourceId}/select_as_outline.json`);
      return response.data.result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data?.error);
    }
  },
);

export const deleteUploadFile = createAsyncThunk<DeleteResponse, DeleteUploadFileID>(
  'DELETE_UPLOAD_FILES',
  async (params) => {
    const response = await axios.delete(`/${params.catalogId}/ai_creation_sources/${params.id}.json`);
    return response.data.result;
  },
);

export const getAllUploadFiles = createAsyncThunk<UploadFilesResponse, CourseCatalogId>(
  'GET_ALL_UPLOAD_FILES',
  async (params) => {
    const response = await axios.get(`/${params.catalogId}/ai_creation_sources.json`);
    return response.data.result;
  },
);


export const getPrevioulsyVisitedCourseList = createAsyncThunk<SearchCourseResult, CourseCatalogId>(
  'GET_COURSES_STYLE_FOR_NOVO_AI_CREATION',
  async (params) => {
    const response = await axios.get(`/${params.catalogId}/ai_creation_style_sources.json`);
    return response.data.result;
  },
);

export const getSearchCourseList = createAsyncThunk<SearchCourseResult, SearchResultParam>(
  'GET_SEARCH_COURSE_STYLE_FOR_NOVO_AI_CREATION',
  async (params) => {
    const response = await axios.get(`/${params.courseCatalogId}/ai_creation_style_sources?search=${params.searchParam}&page_size=${params.pageSize}&page=${params.page}`);
    return response.data.result;
  },
);

export const getPreviewCourseData = createAsyncThunk<PreviewCourseResponse, { courseCatalogId: string, courseId: number }>(
  'GET_PREVIEW_COURSE',
  (params, thunkAPI) => axios.get(
    `/${params.courseCatalogId}/ai_creation_style_sources/${params.courseId}.json`,
  )
    .then((response) => response.data.result)
    .catch((e) => thunkAPI.rejectWithValue(e.response.data.error)),
);


export const markAICourseSummaryModalAsSeen = createAsyncThunk<boolean, { catalogId: string; aiCreationCommandId: number }>(
  'MARK_AI_COURSE_SUMMARY_MODAL_AS_SEEN',
  async ({ catalogId, aiCreationCommandId }) => {
    const response = await axios.put(`${catalogId}/ai_creation_commands/${aiCreationCommandId}/mark_completion_modal_as_seen.json`);

    return response.data.result;
  },
);

export const setSelectedCourse = createAction<number>('SET_SELECTED_COURSE');

export const setGeneratingCourse = createAction<boolean>('SET_GENERATING_COURSE');

export const setGeneratedAICreationData = createAction<AiCreationCommands>('SET_GENERATED_AI_CREATION_DATA');
export const setHasSeenAICourseSummaryModal = createAction<{ commandId: number, value: boolean }>('SET_HAS_SEEN_AI_COURSE_SUMMARY_MODAL');

export const generateAICourse = createAsyncThunk(
  'GENERATE_AI_COURSE',
  (params: {
    courseCatalogId: string,
    contentLength: string,
    styleSourceCourseId: string
  }, thunkAPI) => axios.post(
    `/${params.courseCatalogId}/ai_new.json`,
    {
      course: {
        contentLength: params.contentLength,
        styleSourceCourseId: params.styleSourceCourseId,
      },
    },
  )
    .then((response) => response.data.result)
    .catch((e) => thunkAPI.rejectWithValue(e.response.data.error)),
);
